import React, { useState, useEffect } from "react";

import './refundstatus.css';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import Upperbox from '../components/Upperbox';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';
import Cosection from '../components/Cosections';

const RefundStatus = () => {

      useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
  
  const [activeTab, setActiveTab] = useState("state");

  const mainLinks = [
    { name: "Federal Refund Status", link: "https://sa.www4.irs.gov/irfof/lang/en/irfofgetstatus.jsp", text: "Check Here" },
    { name: "State Refund Status", link: "#state-refunds", text: "Check Here" },
    { name: "Pay Federal Taxes Online", link: "https://www.irs.gov/payments", text: "Pay Here" },
    { name: "Pay State Taxes Online", link: "https://www.officialpayments.com/index.jsp", text: "Pay Here" },
  ];

  const stateLinks = [
    { state: "Alabama (AL)", link: "https://myalabamataxes.alabama.gov/_" },
    { state: "Alaska (AK)", link: "None - Tax free" },
    { state: "Arizona (AZ)", link: "https://www.aztaxes.gov/Home/Login?aspxerrorpath=/Individual/CheckRefund.aspx" },
    { state: "Arkansas (AR)", link: "https://atap.arkansas.gov/_/#1" },
    { state: "California (CA)", link: "https://www.ftb.ca.gov/refund/index.asp?WT.mc_id=akRefund" },
    { state: "Colorado (CO)", link: "https://www.colorado.gov/revenueonline/_/#1" },
    { state: "Connecticut (CT)", link: "https://portal.ct.gov/DRS/Individuals/Income-Tax-Refunds" },
    { state: "Delaware (DE)", link: "https://de.gov/refundstatus" },
    { state: "Florida (FL)", link: "None - Tax free" },
    { state: "Georgia (GA)", link: "https://etax.dor.ga.gov/_/" },
    { state: "Hawaii (HI)", link: "https://tax.hawaii.gov/geninfo/refund/" },
    { state: "Idaho (ID)", link: "https://tax.idaho.gov/i-1040-refund-status.cfm" },
    { state: "Illinois (IL)", link: "https://www.idor.illinois.gov/taxstatus" },
    { state: "Indiana (IN)", link: "https://www.in.gov/dor/tax-returns/" },
    { state: "Iowa (IA)", link: "https://tax.iowa.gov/individual-income-tax-refund-status" },
    { state: "Kansas (KS)", link: "https://www.kdor.ks.gov/tap" },
    { state: "Kentucky (KY)", link: "https://refunds.kentucky.gov/" },
    { state: "Louisiana (LA)", link: "https://www.revenue.louisiana.gov/Refunds" },
    { state: "Maine (ME)", link: "https://www.maine.gov/revenue/taxrelief/RefundStatus" },
    { state: "Maryland (MD)", link: "https://marylandtaxes.gov/" },
    { state: "Massachusetts (MA)", link: "https://www.mass.gov/service-details/check-the-status-of-your-tax-refund" },
    { state: "Michigan (MI)", link: "https://www.michigan.gov/taxes/individual-income-tax/refunds" },
    { state: "Minnesota (MN)", link: "https://www.revenue.state.mn.us/individual-income-tax-refund-status" },
    { state: "Mississippi (MS)", link: "https://www.dor.ms.gov/" },
    { state: "Missouri (MO)", link: "https://mydor.mo.gov/" },
    { state: "Montana (MT)", link: "https://mt.gov/revenue/refundstatus/" },
    { state: "Nebraska (NE)", link: "https://revenue.nebraska.gov/" },
    { state: "Nevada (NV)", link: "None - Tax free" },
    { state: "New Hampshire (NH)", link: "None - Tax free" },
    { state: "New Jersey (NJ)", link: "https://www.state.nj.us/treasury/taxation/" },
    { state: "New Mexico (NM)", link: "https://www.tax.newmexico.gov/individuals/" },
    { state: "New York (NY)", link: "https://www.tax.ny.gov/" },
    { state: "North Carolina (NC)", link: "https://www.ncdor.gov/taxes" },
    { state: "North Dakota (ND)", link: "https://www.nd.gov/tax/individual-income-tax/refund-status" },
    { state: "Ohio (OH)", link: "https://tax.ohio.gov/wps/portal/gov/tax/business/individual-income-tax-refund-status" },
    { state: "Oklahoma (OK)", link: "https://oklahoma.gov/tax" },
    { state: "Oregon (OR)", link: "https://www.oregon.gov/dor/individuals/pages/refund-status.aspx" },
    { state: "Pennsylvania (PA)", link: "https://www.revenue.pa.gov/" },
    { state: "Rhode Island (RI)", link: "https://www.tax.ri.gov/" },
    { state: "South Carolina (SC)", link: "https://www.sctax.org/" },
    { state: "South Dakota (SD)", link: "None - Tax free" },
    { state: "Tennessee (TN)", link: "None - Tax free" },
    { state: "Texas (TX)", link: "None - Tax free" },
    { state: "Utah (UT)", link: "https://tax.utah.gov/" },
    { state: "Vermont (VT)", link: "https://tax.vermont.gov/" },
    { state: "Virginia (VA)", link: "https://www.tax.virginia.gov/refund-status" },
    { state: "Washington (WA)", link: "None - Tax free" },
    { state: "West Virginia (WV)", link: "https://www.tax.wv.gov/" },
    { state: "Wisconsin (WI)", link: "https://www.revenue.wi.gov/" },
    { state: "Wyoming (WY)", link: "None - Tax free" }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case "federal":
        return (
          <div className="refund-table-container">
            <div className="refund-table-header">
              <div className="refund-table-column">Service</div>
              <div className="refund-table-column">Action</div>
            </div>
            <div className="refund-table-row">
              <div className="refund-table-column refund-state-name">Federal Refund Status</div>
              <div className="refund-table-column refund-action-link">
                <a href={mainLinks[0].link} target="_blank" rel="noopener noreferrer" className="refund-action-button">
                  Check Status
                </a>
              </div>
            </div>
          </div>
        );
      case "state":
        return (
          <div className="refund-table-container refund-narrower-table">
            <div className="refund-table-header">
              <div className="refund-table-column">State</div>
              <div className="refund-table-column">Links</div>
            </div>
            {stateLinks.map((item, index) => (
              <div className="refund-table-row" key={index}>
                <div className="refund-table-column refund-state-name">{item.state}</div>
                <div className="refund-table-column refund-action-link">
                  {item.link === "None - Tax free" ? (
                    <span className="refund-tax-free">Tax Free</span>
                  ) : (
                    <a href={item.link} target="_blank" rel="noopener noreferrer" className="refund-action-button">
                      Check Status
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        );
      case "payFederal":
        return (
          <div className="refund-table-container refund-narrower-table">
            <div className="refund-table-header">
              <div className="refund-table-column">Service</div>
              <div className="refund-table-column">Action</div>
            </div>
            <div className="refund-table-row">
              <div className="refund-table-column refund-state-name">Pay Federal Taxes Online</div>
              <div className="refund-table-column refund-action-link">
                <a href={mainLinks[2].link} target="_blank" rel="noopener noreferrer" className="refund-action-button">
                  Make Payment
                </a>
              </div>
            </div>
          </div>
        );
      case "payState":
        return (
          <div className="refund-table-container refund-narrower-table">
            <div className="refund-table-header">
              <div className="refund-table-column">Service</div>
              <div className="refund-table-column">Action</div>
            </div>
            <div className="refund-table-row">
              <div className="refund-table-column refund-state-name">Pay State Taxes Online</div>
              <div className="refund-table-column refund-action-link">
                <a href={mainLinks[3].link} target="_blank" rel="noopener noreferrer" className="refund-action-button">
                  Make Payment
                </a>
              </div>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="refund-status-page">
      <NavBar />

    

      <div className="refund-status-container">

<div className="refund-title-box">
  <h1>Tax Refund Status</h1>
  <p>Track your refunds and manage tax payments with ease</p>
</div>


        <div className="refund-tabs-container">
          <div className="refund-tabs-header">
            <button className={`refund-tab ${activeTab === "state" ? 'active' : ''}`} onClick={() => setActiveTab("state")}>State Refunds</button>
            <button className={`refund-tab ${activeTab === "federal" ? 'active' : ''}`} onClick={() => setActiveTab("federal")}>Federal Refunds</button>
            <button className={`refund-tab ${activeTab === "payFederal" ? 'active' : ''}`} onClick={() => setActiveTab("payFederal")}>Pay Federal</button>
            <button className={`refund-tab ${activeTab === "payState" ? 'active' : ''}`} onClick={() => setActiveTab("payState")}>Pay State</button>
          </div>

          <div className="refund-tab-content">
            {renderTabContent()}
          </div>
        </div>
      </div>

      <Cosection />
      <Whatsapp />
      <ScrollTop />
      <Footer />
    </div>
  );
};

export default RefundStatus;